<template>
  <div class="mapboxgl-custom-legend">
    <!-- GRP legend -->
    <v-card class="legend-container">
      <div class="pa-3">
        <h4 class="caption font-weight-bold">GRP in 100 million Yuan</h4>

        <v-layout class="legend-grp mt-2">
          <v-flex xs4>
            <div class="legend-grp__label" />
            <div class="dotted-line" />
            <div class="dotted-line2" />
          </v-flex>

          <v-flex xs8>
            <v-layout wrap fill-height>
              <v-flex xs12>39,482</v-flex>
              <v-flex xs12 align-self-end>441.36</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>

    <!-- Population legend -->
    <v-card class="legend-container mt-3">
      <div class="pa-3">
        <h4 class="caption font-weight-bold">Cities Population (10,000)</h4>

        <v-layout class="legend-pop mt-2">
          <v-flex xs6 align-self-center>
            <div class="legend-pop__label">
              <div class="dotted-line" />
              <div class="label__inner"/>
              <div class="dotted-line2" />
            </div>
          </v-flex>

          <v-flex xs5 offset-xs1>
            <v-layout wrap fill-height>
              <v-flex xs12 class="caption">879</v-flex>
              <v-flex xs12 align-self-end mb-2 class="caption">53</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LegendGRP',
};
</script>

<style lang="stylus" scoped>
.legend-container {
  max-width: 145px;

  .caption {
    line-height: 1.3;
  }

  .legend-grp {
    height: 13vh;
    position: relative;

    .legend-grp__label {
      position: relative;
      background-image: linear-gradient(#4c3e89, #c4cced);
      width: 50%;
      height: 100%;
    }

    .dotted-line {
      position: absolute;
      top: 5%;
      width: 25%;
      height: 1px;
      border-top: 1px dotted #4c3e89;
    }

    .dotted-line2 {
      position: absolute;
      bottom: 5%;
      width: 25%;
      height: 1px;
      border-top: 1px dotted #c4cced;
    }
  }

  .legend-pop {
    height: 7vh;

    .legend-pop__label {
      position: relative;
      background-color: rgba(255, 101, 5, 0.45);
      border: 1px solid #ff6505;
      border-radius: 50%;
      width: 100%;

      &:before {
        content: '';
        display: block;
        padding-top: 100%;
      }

      .dotted-line {
        position: absolute;
        top: 0;
        left: 50%;
        width: 50%;
        height: 1px;
        border-top: 1px dotted #f38063;
      }

      .dotted-line2 {
        position: absolute;
        bottom: 25%;
        left: 50%;
        width: 50%;
        height: 1px;
        border-top: 1px dotted #f38063;
      }

      .label__inner {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid #ff6505;
        border-radius: 50%;
        width: 25%;
        height: 25%;
      }
    }
  }
}
</style>
